module.exports = __webpack_public_path__ + "media/images/sp/top/icon-location_re-23dabb547e4dd6502f3ebbb59f773205.png";